<template>
  <div class="blog-sidebar">
    <div class="buttons">
      <a href="/league-of-legends/lol-account" v-tooltip.arrow="'League of Legends Accounts'">
        <img src="/images/blog-sidebar/swords.png" alt="all lol accounts">
      </a>
      <a href="/blog" v-tooltip.arrow="'See all blog posts'">
        <img src="/images/blog-sidebar/scroll.png" alt="unrankedsmurfs scroll">
      </a>
      <!-- <a href="#">
        <img src="/images/blog-sidebar/share.png" alt="unrankedsmurfs share">
      </a>-->
      <a href="#comments" v-tooltip.arrow="'Go to the comments'">
        <img src="/images/blog-sidebar/quill.png" alt="unrankedsmurfs quill">
      </a>
    </div>
    <div class="scroll" @mouseleave="hoveredUntil = null">
      <div
        v-for="(node, index) in nodes"
        :key="index"
        :class="[nodeToType(node), isNodeHighlighted(index) && 'viewed']"
        @click="scrollToNode(node)"
        @mouseover="hoveredUntil = index"
        v-tooltip.arrow="nodeToType(node) === 'title' && node.innerText"
      ></div>
    </div>
  </div>
</template>

<script>
import { last, chain, flatMap, filter, isNil } from 'lodash';

export default {
  data() {
    return {
      nodes: [],
      scrollY: 0,
      hoveredUntil: null,
    };
  },

  created() {
    window.addEventListener('scroll', this.handleScroll);
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  mounted() {
    this.nodes = this.computeSidebarNodes();
  },

  methods: {
    scrollToNode(node) {
      window.scrollTo(0, node.offsetTop - 100);
    },

    nodeToType(node) {
      return node.tagName === 'H2' ? 'title' : 'paragraph';
    },

    handleScroll() {
      this.scrollY = window.scrollY;
    },

    isNodeHighlighted(index) {
      if (!isNil(this.hoveredUntil)) {
        return index <= this.hoveredUntil;
      }

      return this.wasNodeViewed(this.nodes[index]);
    },

    wasNodeViewed(node) {
      // A node is "viewed" if it's over the middle of the screen
      return node.offsetTop < this.scrollY + window.innerHeight / 2;
    },

    computeSidebarNodes() {
      const nodes = document.querySelectorAll(
        '.raw-html-container h2, .raw-html-container p'
      );

      // Group the items by consecutive node type (paragraph/title)
      const groups = [...nodes].reduce((groups, node) => {
        const lastGroup = last(groups);
        const nodeType = this.nodeToType(node);

        // If we can't put the item in the last group
        if (!groups.length || lastGroup.type !== nodeType) {
          groups.push({ type: nodeType, items: [node] });
        } else {
          lastGroup.items.push(node);
        }

        return groups;
      }, []);

      // Find the largest sequence of paragraphs
      const maxConsecutiveParapgraphs = chain(groups)
        .filter({ type: 'paragraph' })
        .map(({ items }) => items.length)
        .max()
        .value();

      // Scale these sequences down
      const MAX_PER_GROUP = 6;
      const spreadItems = flatMap(groups, ({ type, items }) => {
        if (type === 'title') {
          return items;
        }

        const takeOneEveryNthItem = Math.max(
          1,
          Math.floor(items.length / MAX_PER_GROUP)
        );

        return chain(items)
          .filter((_, index) => index % takeOneEveryNthItem === 0)
          .take(MAX_PER_GROUP)
          .value();
      });

      return spreadItems;
    },
  },
};
</script>

<style lang="scss" scoped>
.blog-sidebar {
  @apply fixed left-0;
  @apply hidden;
  top: 50%;
  transform: translateY(-50%);

  .buttons {
    @apply border border-l-0 border-honestly-white;
    @apply flex flex-col justify-around;
    @apply pl-3 pr-4;
    height: 350px;

    a {
      @apply flex items-center justify-center;
      height: 50px;
    }
  }

  .scroll {
    @apply flex flex-col justify-between items-center;
    @apply pl-2;

    .title,
    .paragraph {
      @apply cursor-pointer;
      @apply outline-none;

      &.viewed,
      &.viewed:after {
        @apply border-smurfs-gold;
      }
    }

    .title {
      @apply border border-honestly-white;
      @apply my-2;
      width: 14px;
      height: 14px;
      transform: rotate(45deg);
    }

    .paragraph {
      @apply flex-1 relative;
      width: 14px;

      &:after {
        @apply absolute inset-x-0;
        @apply border-b border-honestly-white;
        content: '';
        top: 50%;
      }
    }
  }
}

@screen lg {
  .blog-sidebar {
    @apply flex;
  }
}
</style>
